<template>
	<div>
		<div class="tl-item">
			<div class="tlx-divider">
				<div class="tlx-point"></div>
				<div class="tlx-line"></div>
			</div>
			<div class="tlx-txt">
				<slot name="title"></slot>
				<slot name="content"></slot>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: "SOTimeline"
}
</script>

<style scoped>
.tlx-point {
	background: #6F7287 !important;
}

.tlx-line {
	background: #C8D0DD !important;
}
</style>